import styled from 'styled-components'
import AntLayout from 'antd/lib/layout'
require('antd/lib/layout/style')

const { Header, Sider, Content } = AntLayout

const Layout = styled(AntLayout)`
  max-width: 100%;
  width: 100%;
  min-height: 100%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
`

Layout.Header = Header
Layout.Sider = Sider
Layout.Content = Content

export default Layout
